<template>
  <ChartTitleWrapper :title="title">
    <VueApexCharts type="bar" :height="350" :options="chartOptions" :series="series" />
  </ChartTitleWrapper>
</template>

<script setup>
import { computed } from "vue";
import VueApexCharts from "vue3-apexcharts";

import { getChartOptions } from "@/app/reports/utils/chart";
import { Months } from "@/app/reports/utils/enums";

import ChartTitleWrapper from "@/app/reports/components/charts/ChartTitleWrapper.vue";

const props = defineProps({
  title: String,
  data: Array,
});

const chartOptions = getChartOptions({
  xAxis: {
    title: "Meses",
    categories: Object.values(Months),
  },
  yAxis: {
    title: "Número de llamadas abandonadas",
  },
  chartColors: ["#ADC6FF"],
  singleBar: true,
  legend: {
    show: false,
  },
});

const series = computed(() => {
  const { ene, feb, mar, abr, may, jun, jul, ago, sep, oct, nov, dic } =
    props.data?.find((row) => row.tramo === "Total") || {};

  return [
    {
      name: "",
      data: [ene, feb, mar, abr, may, jun, jul, ago, sep, oct, nov, dic].map(
        (month) => month ?? null
      ),
    },
  ];
});
</script>

<style lang="sass" scoped>
h3
  font-size: 16px
  font-weight: 600
  margin: 35px 0 12px 0
  text-align: center
</style>
